import { withFeatureBranch } from '../../redux/flags';
import { default as MediaSelector } from './LoadableMediaSelector';
import { default as MediaSelectorV2 } from '../../MediaPopup__media_popup_posts/MediaSelector';
export default withFeatureBranch({
    media_popup_posts: MediaSelectorV2,
})(MediaSelector);
//# sourceMappingURL=index.js.map